module.exports = __webpack_public_path__ + "img/image14.7bb9e41.png";